import { BrowserRouter, Routes, Route, Navigate, useParams, useSearchParams } from 'react-router-dom';
import { useContext } from 'react';
import AppContext from "../context";

import LogOut from './LogOut';
import Layout from './experiences/Layout';
import Services from './variable/Services';
import Service from './variable/Service';
import VariableAdminRouter from './variable/admin/AdminRouter';

import Login from './experiences/Login';
import ForgotPassword from './experiences/ForgotPassword';
import ResetPassword from './experiences/ResetPassword';
import CreateAccount from './variable/CreateAccount';

import Dashboard from './dashboard/Dashboard';
import ServiceList from './dashboard/services/ServiceList';
import ServiceBook from './dashboard/services/ServiceBook';
import ServiceBookingDetail from './dashboard/services/ServiceBookingDetail';
import MyServiceBookings from './dashboard/services/MyServiceBookings';
import Account from './dashboard/account/Account';
import DashboardWallet from './dashboard/wallet';

const ServiceBookingRedirect = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const success = searchParams.get('success');
    return <Navigate to={`/dashboard/service-bookings/${id}${success ? '?success=true' : ''}`} replace />;
};

const VariableRouter = () => {
    const context = useContext(AppContext);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="log-out" element={<LogOut />} />

                {context.user?.admin
                    ? <Route path="/admin/*" element={<VariableAdminRouter />} />
                    : null
                }

                {context.user && !context.user.admin ? (
                    <Route path="dashboard" element={<Dashboard />}>
                        <Route path="services" element={<ServiceList />} />
                        <Route path="services/:id" element={<ServiceBook />} />
                        <Route path="service-bookings/:id" element={<ServiceBookingDetail />} />
                        <Route path="my-service-bookings" element={<MyServiceBookings />} />
                        <Route path="wallet" element={<DashboardWallet.Template />}>
                            <Route index element={<DashboardWallet.List />} />
                            <Route path="checkout/:id" element={<DashboardWallet.Checkout />} />
                        </Route>
                        <Route path="settings" element={<Account />} />
                    </Route>
                ) : null}

                <Route path="" element={<Layout />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/create-account" element={<CreateAccount />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/services/:id" element={<Service />} />
                    <Route path="/account/service-bookings/:id" element={<ServiceBookingRedirect />} />
                    <Route path="/" element={<Services />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default VariableRouter;
